import Grid from '@mui/material/Grid';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import React from 'react';

import SortingIcon from '../../../components/SortingIcon/SortingIcon';
import useStyles from './fleetStyle';

const DriverHeader: React.FC<{
  fleetHeader: any;
  fleetStore: any;
}> = ({ fleetHeader, fleetStore }) => {
  const classes = useStyles();
  const sortBY = async (e: any) => {
    fleetStore.setSortBy(e);
    fleetStore.setSortDirection(
      fleetStore.SortDirection === 'desc' ? 'asc' : 'desc',
    );
    fleetStore.setShowLoader(true);
    fleetStore.setFleetList([]);
    await fleetStore.fetchFleetsBySorting();
    fleetStore.setShowLoader(false);
  };

  return (
    <TableRow>
      {fleetHeader.map((header: any, index: number) => (
        <TableCell key={index} className={classes.tableHeaderBg}>
          <Grid item xs={12}>
            <Typography
              component={'div'}
              noWrap
              style={{ alignItems: 'center', display: 'flex' }}>
              <Typography
                component={'div'}
                sx={{
                  color: header.name === 'name' ? '#241A2E' : '#979598',
                  fontFamily: 'FiraSans-Regular',
                  fontSize: '12px',
                  letterSpacing: 0,
                  lineHeight: '14px',
                }}>
                {header.label}
              </Typography>

              {header !== '' && header.name !== '' && (
                <SortingIcon
                  {...{ sortBY, sortByName: header.name, store: fleetStore }}
                />
              )}
            </Typography>
            <br />
          </Grid>
        </TableCell>
      ))}
    </TableRow>
  );
};

export default observer(DriverHeader);
